export default import.meta.ROLLUP_FILE_URL_7PUm3F_uVf$21BIFLSklvQ;